import { Typography } from '@kizen/kds/Typography';
import { CSSProperties } from 'react';
import classNames from 'classnames';

type HeaderProps = {
  labels: {
    span?: number;
    label: string;
  }[];
  className?: string;
};

export const Header = (props: HeaderProps) => {
  const { labels = [], className } = props;

  const totalSpan = labels.reduce((acc, label) => acc + (label.span || 1), 0);

  return (
    <div
      className={classNames(
        'grid grid-cols-[repeat(var(--column-count),minmax(0,1fr))]',
        className
      )}
      style={{ '--column-count': totalSpan } as CSSProperties}
    >
      {labels.map((label, index) => (
        <div
          className={`flex items-center ${index === labels.length - 1 ? 'justify-end' : ''}`}
          key={label.label}
          style={{
            gridColumn: `span ${label.span ?? 1} / span ${label.span ?? 1}`,
          }}
        >
          <Typography weight="semibold" size="md">
            {label.label}
          </Typography>
        </div>
      ))}
    </div>
  );
};
